import global from "./global.js";
import auth from "./auth.js";
import emitter from "./emitter.js";
import masonry from "./masonry.js";
import infinite from "./infinite-loading.js";
import icons from "./icons.js";
import img from "./img.js";
import moment from "./moment.js";
import sweetalert from "./sweetalert.js";
import pageMaker from "./pageMaker.js";
import components from "./components.js";
import vuePlyr from "./vue-plyr.js";
import { vMaska } from "maska/vue";
import translations from "./translations.js";
const BanzaPlugin = {
  install: (app, options) => {
    app.use(global, options);
    app.use(auth);
    app.use(components);
    app.use(emitter);
    app.use(masonry);
    app.use(infinite);
    app.use(icons);
    app.use(img, options);
    app.use(moment);
    app.use(sweetalert, options);
    app.use(pageMaker);
    app.use(vuePlyr);
    app.directive("maska", vMaska);
    app.use(translations);
  }
};
export {
  BanzaPlugin as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9wbHVnaW5zL2JhbnphL2luZGV4LmpzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBnbG9iYWwgZnJvbSBcIi4vZ2xvYmFsXCI7XG5pbXBvcnQgYXV0aCBmcm9tIFwiLi9hdXRoXCI7XG5pbXBvcnQgZW1pdHRlciBmcm9tIFwiLi9lbWl0dGVyXCI7XG5pbXBvcnQgbWFzb25yeSBmcm9tIFwiLi9tYXNvbnJ5XCI7XG5pbXBvcnQgaW5maW5pdGUgZnJvbSBcIi4vaW5maW5pdGUtbG9hZGluZ1wiO1xuaW1wb3J0IGljb25zIGZyb20gXCIuL2ljb25zXCI7XG5pbXBvcnQgaW1nIGZyb20gXCIuL2ltZ1wiO1xuaW1wb3J0IG1vbWVudCBmcm9tIFwiLi9tb21lbnRcIjtcbmltcG9ydCBzd2VldGFsZXJ0IGZyb20gXCIuL3N3ZWV0YWxlcnRcIjtcbmltcG9ydCBwYWdlTWFrZXIgZnJvbSBcIi4vcGFnZU1ha2VyXCI7XG5pbXBvcnQgY29tcG9uZW50cyBmcm9tIFwiLi9jb21wb25lbnRzXCI7XG5pbXBvcnQgdnVlUGx5ciBmcm9tIFwiLi92dWUtcGx5clwiO1xuaW1wb3J0IHsgdk1hc2thIH0gZnJvbSBcIm1hc2thL3Z1ZVwiO1xuaW1wb3J0IHRyYW5zbGF0aW9ucyBmcm9tIFwiLi90cmFuc2xhdGlvbnNcIjtcblxuZXhwb3J0IGRlZmF1bHQge1xuXHRpbnN0YWxsOiAoYXBwLCBvcHRpb25zKSA9PiB7XG5cdFx0YXBwLnVzZShnbG9iYWwsIG9wdGlvbnMpO1xuXHRcdGFwcC51c2UoYXV0aCk7XG5cdFx0YXBwLnVzZShjb21wb25lbnRzKTtcblx0XHRhcHAudXNlKGVtaXR0ZXIpO1xuXHRcdGFwcC51c2UobWFzb25yeSk7XG5cdFx0YXBwLnVzZShpbmZpbml0ZSk7XG5cdFx0YXBwLnVzZShpY29ucyk7XG5cdFx0YXBwLnVzZShpbWcsIG9wdGlvbnMpO1xuXHRcdGFwcC51c2UobW9tZW50KTtcblx0XHRhcHAudXNlKHN3ZWV0YWxlcnQsIG9wdGlvbnMpO1xuXHRcdGFwcC51c2UocGFnZU1ha2VyKTtcblx0XHRhcHAudXNlKHZ1ZVBseXIpO1xuXHRcdGFwcC5kaXJlY3RpdmUoXCJtYXNrYVwiLCB2TWFza2EpO1xuXHRcdGFwcC51c2UodHJhbnNsYXRpb25zKTtcblx0fSxcbn07XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7QUFlQSxNQUFlLGNBQUE7QUFBQSxFQUNkLFNBQVMsQ0FBQyxLQUFLLFlBQVk7QUFDMUIsUUFBSSxJQUFJLFFBQVEsT0FBTztBQUN2QixRQUFJLElBQUksSUFBSTtBQUNaLFFBQUksSUFBSSxVQUFVO0FBQ2xCLFFBQUksSUFBSSxPQUFPO0FBQ2YsUUFBSSxJQUFJLE9BQU87QUFDZixRQUFJLElBQUksUUFBUTtBQUNoQixRQUFJLElBQUksS0FBSztBQUNiLFFBQUksSUFBSSxLQUFLLE9BQU87QUFDcEIsUUFBSSxJQUFJLE1BQU07QUFDZCxRQUFJLElBQUksWUFBWSxPQUFPO0FBQzNCLFFBQUksSUFBSSxTQUFTO0FBQ2pCLFFBQUksSUFBSSxPQUFPO0FBQ2YsUUFBSSxVQUFVLFNBQVMsTUFBTTtBQUM3QixRQUFJLElBQUksWUFBWTtBQUFBLEVBQ3BCO0FBQ0Y7In0=
